import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
// import {  SavedSuccessGreenTickCircle } from "../assets/assets"
import { CrossIcon, SavedSuccessGreenTickCircle } from "../../../assets/images";
import { secondary } from "../../../theme/colors";
import { PrintSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
// import { PlusIcon } from "../../../assets/images" 
export var JCIReturnSavedSuccessfullyComponent = function (_ref) {
    var onClose = _ref.onClose;
    var formData = [{
            type: FormItemTypes.Typography,
            name: 'title',
            children: /*#__PURE__*/ React.createElement("img", {
                alt: "close",
                src: SavedSuccessGreenTickCircle,
                height: "48px",
                width: "48px"
            }),
            columnSize: true
        }, {
            type: FormItemTypes.IconButton,
            name: 'close',
            children: /*#__PURE__*/ React.createElement("img", {
                alt: "close",
                src: CrossIcon
            }),
            sx: {
                marginTop: "10px"
            },
            // onClick: onCrossClick,
            onClick: function () {
                onClose();
            },
            columnSize: 0
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            label: '',
            value: null,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: 'Saved successfully!',
                    // sx: { marginTop: "10px" },
                    fontSize: "xl",
                    fontWeight: 'strong',
                    columnSize: 12
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "JC invoice return no:",
                    color: 'text.tertiary',
                    fontSize: "base",
                    fontWeight: "normal",
                    columnSize: 0
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    fontSize: "base",
                    fontWeight: "medium",
                    children: "SE66178201500001",
                    color: 'text.primary',
                    columnSize: 0
                }],
            columnSize: 12
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "Return invoice summary",
                    fontSize: "base",
                    fontWeight: "medium",
                    columnSize: 12
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "Paid amount",
                    columnSize: 11,
                    fontSize: "sm",
                    fontWeight: "medium"
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "20",
                    display: "flex",
                    justifyContent: "center",
                    columnSize: 1,
                    fontSize: "base",
                    fontWeight: "normal",
                    color: 'secondary.900'
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "Claim amount",
                    columnSize: 11,
                    fontSize: "sm",
                    fontWeight: "medium"
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "20",
                    display: "flex",
                    justifyContent: "center",
                    columnSize: 1,
                    fontSize: "base",
                    fontWeight: "normal",
                    color: 'secondary.900'
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "Expense amount",
                    columnSize: 11,
                    fontSize: "sm",
                    fontWeight: "medium"
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "20",
                    display: "flex",
                    justifyContent: "center",
                    columnSize: 1,
                    fontSize: "base",
                    fontWeight: "normal",
                    color: 'secondary.900'
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "Total discount",
                    columnSize: 11,
                    fontSize: "sm",
                    fontWeight: "medium"
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "20",
                    display: "flex",
                    justifyContent: "center",
                    columnSize: 1,
                    fontSize: "base",
                    fontWeight: "normal",
                    color: 'secondary.900'
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "Total tax",
                    columnSize: 11,
                    fontSize: "sm",
                    fontWeight: "medium"
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "20",
                    display: "flex",
                    justifyContent: "center",
                    columnSize: 1,
                    fontSize: "base",
                    fontWeight: "normal",
                    color: 'secondary.900'
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "Net returnable amount",
                    columnSize: 11,
                    fontSize: 'base',
                    fontWeight: "medium"
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: "20",
                    display: "flex",
                    justifyContent: "center",
                    columnSize: 1,
                    fontSize: "base",
                    fontWeight: "strong"
                }
                // {
                //     type: FormItemTypes.Typography,
                //     name: '',
                //     variant: "h6",
                //     children: "Issued qty",
                //     columnSize: 11
                // },
                // {
                //     type: FormItemTypes.Typography,
                //     name: '',
                //     variant: "h6",
                //     children: "20",
                //     display: "flex",
                //     justifyContent: "center",
                //     columnSize: 1,
                // }
            ],
            sx: {
                bgcolor: secondary[50],
                borderRadius: "8px"
            },
            // padding: "10px",
            columnSize: 12
        },
        // {
        //     type: FormItemTypes.Button,
        //     name: '',
        //     children: "Go to homepage",
        //     fullWidth: true,
        //     size: "small",
        //     sx: {
        //         py: 0.5,
        //         color: "secondary.600",
        //         border: '1px solid',
        //         borderColor:'secondary.200',
        //         fontWeight: "medium",
        //         fontSize: 'lg'
        //     },
        //     columnSize: 12
        // },
        {
            type: FormItemTypes.ContainerItem,
            name: "",
            label: "",
            value: null,
            columnSize: 12,
            spacing: 0,
            // padding: '0px 0px 24px 24px',
            gap: '12px',
            justifyContent: 'space-between',
            elements: [{
                    type: FormItemTypes.Button,
                    name: "",
                    children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                    columnSize: 0,
                    variant: "outlined",
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                    columnSize: 0,
                    variant: 'outlined',
                    color: 'secondary'
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Go to homepage',
                    xs: 6.5,
                    sm: 6,
                    md: 8,
                    lg: 8,
                    variant: 'contained',
                    fullWidth: true,
                    color: 'primary',
                    sx: {
                        fontSize: 'lg',
                        fontWeight: 'medium'
                    },
                    onClick: function () {
                        onClose('goHome');
                    }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: 2,
            gap: 2,
            spacing: 0
        }
    }));
};
